/* ============================================================
   SORRY NONNA - shared behaviour + motion
   ============================================================ */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Sticky nav shadow ---------- */
  function initStickyNav() {
    var nav = document.querySelector(".nav");
    if (!nav) return;
    var onScroll = function () {
      nav.classList.toggle("is-stuck", window.scrollY > 6);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile burger ---------- */
  function initBurger() {
    var burger = document.querySelector(".nav__burger");
    var links = document.querySelector(".nav__links");
    if (!burger || !links) return;
    burger.addEventListener("click", function () {
      var open = links.classList.toggle("open");
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    links.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        links.classList.remove("open");
        burger.classList.remove("open");
      });
    });
  }

  /* ---------- Scroll reveal - REMOVED 2026-08-07 ----------
     Content is visible on paint now; the CSS in sn-base.css renders .reveal and .reveal-scale in
     their final state. What lived here was an IntersectionObserver over every such element, a
     stagger pass that wrote per-element --d delays, plus a failsafe that ran on load, on a
     1200ms timer AND on every scroll event site-wide - all of which now has nothing to do.

     The one thing worth keeping is the `in` class. Three other places still add it directly
     (the review wall, the card fan, the filtered shop grid), so anything holding a stale
     `.reveal:not(.in)` assumption stays satisfied without this observer existing.

     To bring the animation back: restore the block below from git history and undo the
     neutralised rules in sn-base.css. Nothing else was touched. */
  function initReveal() {
    document.querySelectorAll(".reveal, .reveal-scale").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Parallax (data-parallax = speed) ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.15;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = "translate3d(0," + (-mid * speed).toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Count up numbers (data-countup) ---------- */
  function initCountUp() {
    var els = document.querySelectorAll("[data-countup]");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute("data-countup"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute("data-countup"), 10) || 0;
        var prefix = el.getAttribute("data-prefix") || "";
        var suffix = el.getAttribute("data-suffix") || "";
        if (reduceMotion) { el.textContent = prefix + target + suffix; io.unobserve(el); return; }
        var start = null, dur = 1400;
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.floor(eased * target) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target + suffix;
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.querySelectorAll("[data-accordion] .acc__trigger").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".acc");
        var body = item.querySelector(".acc__body");
        var open = item.classList.toggle("is-open");
        body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
      });
    });
  }

  /* ---------- Collection facets - real Shopify filtering over AJAX ----------
     The filter pills live in `collection-filters` (just above the grid, below the bundle)
     and the grid in `main-collection`, so this runs document-wide: it fetches the filtered
     collection page and swaps BOTH [data-filters] and [data-grid-results] in place,
     keeping the spill animation. Progressive enhancement over the plain GET <form>. */
  function initCollectionFacets() {
    var grid = document.querySelector("[data-grid-results]");
    if (!grid) { return; }
    var urlEl = document.querySelector("[data-collection-url]");
    var baseUrl = (urlEl && urlEl.getAttribute("data-collection-url")) || window.location.pathname;
    var reqSeq = 0;
    var debTimer = null;

    /* Shop-page show/hide for the featured bundle. Its own categories come from the bundle
       product (data-collection-bundle, pipe-separated: taxonomy category + type + tags).
       Show when: no filter is active (sits at the top), OR an active pill matches one of the
       bundle's categories. If the bundle has no category assigned yet, always show. Nothing
       is hardcoded - assign the category to the bundle product and it just works. */
    function bundleTokens() {
      var b = document.querySelector("[data-collection-bundle]");
      var raw = (b && b.getAttribute("data-collection-bundle")) || "";
      return raw.split("|").map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    }
    function bundleShouldShow() {
      var filters = document.querySelector("[data-filters]");
      if (!filters) { return true; }
      var active = Array.prototype.map.call(
        filters.querySelectorAll(".cactive .chip span:first-child"),
        function (s) { return s.textContent.trim().toLowerCase(); }
      );
      if (!active.length) { return true; }          /* no active filters → show at top */
      var tokens = bundleTokens();
      if (!tokens.length) { return true; }          /* bundle has no category yet → always show */
      return active.some(function (label) { return tokens.indexOf(label) !== -1; });
    }
    function setBundle(show) {
      var b = document.querySelector("[data-collection-bundle]");
      if (!b) { return; }
      if (reduceMotion) {
        b.classList.toggle("is-collapsed", !show);
        b.classList.toggle("is-gone", !show);
        return;
      }
      if (show) {
        if (!b.classList.contains("is-gone") && !b.classList.contains("is-collapsed")) { return; }
        b.classList.remove("is-gone");
        requestAnimationFrame(function () { b.classList.remove("is-collapsed"); });
      } else {
        if (b.classList.contains("is-gone")) { return; }
        var onEnd = function (ev) {
          if (ev.target !== b || ev.propertyName !== "opacity") { return; }
          b.classList.add("is-gone");
          b.removeEventListener("transitionend", onEnd);
        };
        b.addEventListener("transitionend", onEnd);
        b.classList.add("is-collapsed");
      }
    }

    /* combine values from every filter form on the page (pills, price…) */
    function collectParams() {
      var params = new URLSearchParams();
      document.querySelectorAll("[data-filter-form]").forEach(function (form) {
        new FormData(form).forEach(function (val, key) {
          if (String(val).trim() === "") { return; } /* drop empty price fields */
          params.append(key, val);
        });
      });
      return params;
    }

    /* current grid cards shrink & spill up out of view - fire-and-forget, so it
       plays concurrently with the fetch instead of delaying it */
    function spillOut() {
      var cards = Array.prototype.slice.call(document.querySelectorAll(".pgrid .gcard"));
      if (reduceMotion || !cards.length) { return; }
      cards.forEach(function (c, i) {
        c.style.transition = "transform .38s var(--ease-out), opacity .38s var(--ease-out)";
        c.style.transitionDelay = (i * 20) + "ms";
        c.style.transform = "translateY(-42px) scale(.6) rotate(" + (Math.random() * 14 - 7) + "deg)";
        c.style.opacity = "0";
      });
    }

    /* incoming grid cards rise + fade in, staggered (reuses the .reveal/.in CSS) */
    function revealGrid() {
      var cards = Array.prototype.slice.call(document.querySelectorAll(".pgrid .reveal"));
      if (reduceMotion) { cards.forEach(function (c) { c.classList.add("in"); }); return; }
      cards.forEach(function (c, i) { c.style.setProperty("--d", (i * 55) + "ms"); });
      requestAnimationFrame(function () {
        cards.forEach(function (c) { c.classList.add("in"); });
      });
    }

    function swap(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      ["[data-filters]", "[data-grid-results]"].forEach(function (sel) {
        var next = doc.querySelector(sel);
        var cur = document.querySelector(sel);
        if (next && cur) { cur.innerHTML = next.innerHTML; }
      });
      /* swapped-in pills carry .reveal but won't be re-observed - show them at once */
      var f = document.querySelector("[data-filters]");
      if (f) { f.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); }); }
      revealGrid();
      setBundle(bundleShouldShow());
    }

    /* Fetch starts immediately and the spill animation plays over it, so the wait is
       ~max(render, 300ms) instead of animation + render in series. A sequence id makes
       the latest request win; the 300ms floor stops the swap snapping in mid-animation
       when the network is fast (production). */
    function render(url, push) {
      var myReq = ++reqSeq;
      var target = new URL(url, window.location.origin);
      spillOut();
      var floor = new Promise(function (res) { setTimeout(res, reduceMotion ? 0 : 300); });
      var fetched = fetch(target.toString()).then(function (r) { return r.text(); });
      Promise.all([fetched, floor])
        .then(function (parts) {
          if (myReq !== reqSeq) { return; } /* a newer request landed first */
          swap(parts[0]);
          if (push) { history.pushState({ snFacets: true }, "", target.toString()); }
        })
        .catch(function () { if (myReq === reqSeq) { window.location.href = target.toString(); } });
    }

    function applyFilters() {
      clearTimeout(debTimer);
      var qs = collectParams().toString();
      render(baseUrl + (qs ? "?" + qs : ""), true);
    }

    /* pill toggles / price changes debounce (coalesce quick multi-selects) */
    document.addEventListener("change", function (e) {
      if (!e.target.closest("[data-filter-form]")) { return; }
      clearTimeout(debTimer);
      debTimer = setTimeout(applyFilters, 150);
    });
    /* Enter inside a price field, or the no-JS "Apply" button */
    document.addEventListener("submit", function (e) {
      if (e.target.closest("[data-filter-form]")) { e.preventDefault(); applyFilters(); }
    });
    /* pagination links + active-filter chips + clear-all (delegated → survives swaps) */
    document.addEventListener("click", function (e) {
      var a = e.target.closest("a");
      if (!a) { return; }
      if (a.closest(".pgrid__pagination") || a.hasAttribute("data-facet-link")) {
        e.preventDefault();
        render(a.getAttribute("href"), true);
      }
    });
    window.addEventListener("popstate", function () { render(window.location.href, false); });

    /* initial state: if the page loaded with a sauce-excluding filter, hide the bundle instantly */
    if (!bundleShouldShow()) {
      var b0 = document.querySelector("[data-collection-bundle]");
      if (b0) { b0.classList.add("is-collapsed", "is-gone"); }
    }
  }

  /* ---------- Infinite seamless centred carousel ---------- */
  function initCarousels() {
    document.querySelectorAll("[data-carousel]").forEach(function (root) {
      var track = root.querySelector(".carousel__track");
      var originals = Array.prototype.slice.call(track.children);
      var N = originals.length;
      if (N < 2) return;
      var nameEl = root.querySelector("[data-carousel-name]");
      var badgeEl = root.querySelector("[data-carousel-badge]");
      var prev = root.querySelector("[data-carousel-prev]");
      var next = root.querySelector("[data-carousel-next]");

      /* clone a full set before and after for a seamless loop */
      var after = document.createDocumentFragment();
      var before = document.createDocumentFragment();
      originals.forEach(function (c) { after.appendChild(c.cloneNode(true)); });
      originals.slice().reverse().forEach(function (c) { before.appendChild(c.cloneNode(true)); });
      track.appendChild(after);
      track.insertBefore(before, track.firstChild);

      var cards = Array.prototype.slice.call(track.children); /* 3N, originals at [N .. 2N-1] */
      var idx = N;
      var animating = false;

      /* Card x-positions are pure layout - a transform does not move offsetLeft - so they
         only change on resize. Cache them: a drag asks "which card is nearest?" on every
         pointermove, and doing that with live offsetLeft reads meant a full layout flush
         per frame, which is most of what made the swipe feel gluey (#127). */
      var posCache = null;
      function invalidate() { posCache = null; }
      function positions() {
        if (!posCache) {
          var panelW = track.parentElement.offsetWidth;
          posCache = cards.map(function (c) { return panelW / 2 - (c.offsetLeft + c.offsetWidth / 2); });
        }
        return posCache;
      }
      /* Ease-OUT for gesture-driven moves, not the ease-in-out the autoplay uses. A snap
         has to pick up where the finger left off, so it starts at speed and decelerates;
         ease-in-out starts slow, which reads as lag however short you make it. */
      var SNAP_EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)";

      function setActive(i) {
        cards.forEach(function (c, k) { c.classList.toggle("is-active", k === i); });
        var real = originals[((i - N) % N + N) % N];
        if (nameEl) nameEl.textContent = real.getAttribute("data-name") || "";
        if (badgeEl) { badgeEl.textContent = real.getAttribute("data-badge") || "View"; badgeEl.href = real.getAttribute("data-url") || "#"; }
      }
      function apply(animate, ms, ease) {
        track.style.transition = animate ? ("transform " + (ms || 700) + "ms " + (ease || "var(--ease-in-out)")) : "none";
        track.style.transform = "translate3d(" + positions()[idx] + "px,0,0)";
        setActive(idx);
      }
      function go(dir, ms, ease) { if (animating) return; animating = true; idx += dir; apply(true, ms, ease); }

      /* Live x of the track, so a snap still in flight can be caught mid-move. */
      function currentX() {
        var t = window.getComputedStyle(track).transform;
        if (!t || t === "none") { return positions()[idx]; }
        var m3 = t.match(/matrix3d\(([^)]+)\)/);
        if (m3) { return parseFloat(m3[1].split(",")[12]); }
        var m2 = t.match(/matrix\(([^)]+)\)/);
        if (m2) { return parseFloat(m2[1].split(",")[4]); }
        return positions()[idx];
      }
      /* Which card sits closest to a given track x. Kept one off each end so the
         loop wrap in transitionend always has somewhere to go. */
      function nearestIdx(x) {
        var p = positions(), best = idx, bestD = Infinity;
        for (var i = 0; i < p.length; i++) {
          var d = Math.abs(p[i] - x);
          if (d < bestD) { bestD = d; best = i; }
        }
        return Math.max(1, Math.min(p.length - 2, best));
      }

      track.addEventListener("transitionend", function (e) {
        if (e.propertyName !== "transform") return;
        animating = false;
        if (idx >= 2 * N) { idx -= N; apply(false); }
        else if (idx < N) { idx += N; apply(false); }
      });

      /* Arrows get the same quick ease-out a swipe gets. The languid 0.7s ease-in-out is
         right for the unattended autoplay drift, but as a response to a tap it feels slow. */
      prev && prev.addEventListener("click", function () { go(-1, 380, SNAP_EASE); restart(); });
      next && next.addEventListener("click", function () { go(1, 380, SNAP_EASE); restart(); });
      cards.forEach(function (c, i) {
        c.addEventListener("click", function (e) {
          /* The card is a real <a> now (#147), so the CENTRED one needs no handling at all -
             letting the browser follow the href is what makes middle-click, cmd-click and
             "open in new tab" work, none of which a window.location.href assignment supports.
             Only an off-centre card is intercepted, to bring it to the middle first. */
          if (i === idx) return;
          e.preventDefault();
          if (animating) return;
          idx = i; animating = true; apply(true, 380, SNAP_EASE); restart();
        });
      });

      var timer;
      function restart() { if (reduceMotion) return; clearInterval(timer); timer = setInterval(function () { go(1); }, 3800); }

      /* ---- Swipe to move (#127) -------------------------------------------
         Until now the only ways to move this were the two arrows and the 3.8s
         autoplay, so on a phone the one gesture everybody actually tries - a
         swipe - did nothing at all. That reads as broken rather than static.
         Drag the track with the finger and snap to the nearest card on release.

         Vertical intent wins. The first few pixels decide whether this is a
         swipe or a page scroll; on a scroll we drop the drag and never touch
         the transform, so the page still scrolls normally over the carousel.
         touch-action:pan-y in the CSS tells the browser the same thing, and
         that is what actually suppresses the horizontal pan - preventDefault
         on pointermove does not reliably do it.

         suppressClick exists because a drag that finishes on a card still
         fires a click, and the card's own handler navigates to the product.
         Swiping must never take you off the page. */
      var drag = null;
      var suppressClick = false;

      function dragStart(x, y) {
        var startX;
        if (animating) {
          /* Catch the snap in flight rather than ignoring the touch. Refusing to start
             a drag while animating is what made a second swipe feel like it had been
             swallowed - at 3.8s autoplay there is nearly always something in flight. */
          startX = currentX();
          track.style.transition = "none";
          track.style.transform = "translate3d(" + startX + "px,0,0)";
          animating = false;
          idx = nearestIdx(startX);
          setActive(idx);
        } else {
          startX = positions()[idx];
        }
        drag = { x0: x, y0: y, dx: 0, axis: null, base: startX, vx: 0, lastX: x, lastT: Date.now() };
        clearInterval(timer);
      }
      function dragMove(x, y) {
        if (!drag) return;
        var dx = x - drag.x0, dy = y - drag.y0;
        if (!drag.axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; /* too small to read intent yet */
          drag.axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
          if (drag.axis === "y") { drag = null; restart(); return; }
        }
        var now = Date.now(), dt = now - drag.lastT;
        /* Smoothed px/ms. A single frame's delta is far too noisy to throw with. */
        if (dt > 0) { drag.vx = 0.7 * ((x - drag.lastX) / dt) + 0.3 * drag.vx; }
        drag.lastX = x; drag.lastT = now;
        drag.dx = dx;
        track.style.transition = "none";
        track.style.transform = "translate3d(" + (drag.base + dx) + "px,0,0)";
        /* Hand the centred styling over as the finger passes each card, so the scale and
           the caption track the gesture instead of all changing at the end. */
        var near = nearestIdx(drag.base + dx);
        if (near !== idx) { idx = near; setActive(idx); }
      }
      function dragEnd() {
        if (!drag) return;
        var d = drag;
        drag = null;
        restart();
        if (d.axis !== "x") return;
        suppressClick = Math.abs(d.dx) > 6;
        var vx = Math.max(-2.5, Math.min(2.5, d.vx || 0)); /* px/ms, clamped against flings */
        /* Throw the gesture ~150ms forward and land on whatever card is nearest. Distance
           alone ignored how fast you moved, so a quick flick that travelled barely half a
           card just sagged back - the single biggest reason this felt clunky. */
        var landing = d.base + d.dx + vx * 150;
        var target = nearestIdx(landing);
        if (target === idx && Math.abs(vx) > 0.5) { target = nearestIdx(landing + (vx < 0 ? -1 : 1) * 90); }
        /* Duration follows the distance left to travel, so short settles are quick and
           longer throws still decelerate rather than teleporting. */
        var dist = Math.abs(positions()[target] - (d.base + d.dx));
        var ms = Math.max(230, Math.min(460, 230 + dist * 0.75));
        if (target !== idx) { idx = target; animating = true; }
        apply(true, ms, SNAP_EASE); /* target===idx settles back, animating stays false */
      }

      track.addEventListener("click", function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true); /* capture, so it beats the card's own click handler */

      if ("PointerEvent" in window) {
        /* Capture is taken only once the gesture is definitely a horizontal drag, NEVER on
           pointerdown (#147). setPointerCapture retargets the following click at the capturing
           element, so capturing up front sent every click to the track and the card's own link
           never saw it - the cards simply did not open. Exactly the fault fixed in the jar
           scroller and the Instagram strip in #137; this carousel was missed at the time.
           Waiting for drag.axis === "x" means a plain click never captures at all. */
        var captured = false;
        track.addEventListener("pointerdown", function (e) {
          if (e.pointerType === "mouse" && e.button !== 0) return;
          captured = false;
          dragStart(e.clientX, e.clientY);
        });
        track.addEventListener("pointermove", function (e) {
          dragMove(e.clientX, e.clientY);
          if (!captured && drag && drag.axis === "x") {
            captured = true;
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
        });
        track.addEventListener("pointerup", function (e) {
          if (captured) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} }
          captured = false;
          dragEnd();
        });
        track.addEventListener("pointercancel", function () { captured = false; dragEnd(); });
      } else {
        track.addEventListener("touchstart", function (e) { var t = e.touches[0]; dragStart(t.clientX, t.clientY); }, { passive: true });
        track.addEventListener("touchmove", function (e) { var t = e.touches[0]; dragMove(t.clientX, t.clientY); }, { passive: true });
        track.addEventListener("touchend", dragEnd);
        track.addEventListener("touchcancel", dragEnd);
      }
      /* Every re-measure below has to drop the position cache first, or the carousel keeps
         centring on where the cards used to be. Especially on the first paint: if this runs
         before layout, offsetWidth is 0 and an un-invalidated cache would pin every card
         at the same spot for the life of the page. */
      window.addEventListener("resize", function () { invalidate(); apply(false); });
      window.addEventListener("load", function () { invalidate(); apply(false); });

      /* If init happened while the section was hidden (offline bundle / display:none),
         offsetWidth is 0 - keep retrying until it lays out, then re-apply once visible. */
      function ensureLaid(tries) {
        if (track.parentElement.offsetWidth > 0) { invalidate(); apply(false); return; }
        if (tries <= 0) return;
        requestAnimationFrame(function () { ensureLaid(tries - 1); });
      }
      if ("IntersectionObserver" in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { invalidate(); apply(false); } });
        }, { threshold: 0.01 });
        vio.observe(root);
      }

      apply(false);
      requestAnimationFrame(function () { invalidate(); apply(false); });
      ensureLaid(60);
      restart();
    });
  }

  /* ---------- Review wall - cards pop out of the crowd, 4 at a time ---------- */
  function initReviewWall() {
    document.querySelectorAll("[data-review-wall]").forEach(function (wall) {
      // Concat every [data-review-pool] island (live Judge.me reviews first, then house blocks)
      var pool = [];
      Array.prototype.slice.call(wall.querySelectorAll('script[data-review-pool]')).forEach(function (el) {
        try { var arr = JSON.parse(el.textContent); if (arr && arr.length) pool = pool.concat(arr); } catch (e) {}
      });
      if (!pool.length) return;
      // Only cycle slots that are actually visible (mobile shows a single card; desktop all four).
      var slots = Array.prototype.slice.call(wall.querySelectorAll(".review-card")).filter(function (s) { return s.offsetParent !== null; });
      if (!slots.length) return;
      var shown = [];
      function render(slot, item) {
        slot.innerHTML = '<span class="rc-stars">\u2605\u2605\u2605\u2605\u2605</span><p>' + item.t +
          '</p><span class="rc-name">' + item.n + '</span><span class="rc-prod">' + item.p + '</span>';
      }
      slots.forEach(function (slot, i) { shown[i] = i % pool.length; render(slot, pool[shown[i]]); });
      if (reduceMotion || pool.length <= slots.length) return;
      setInterval(function () {
        var si = Math.floor(Math.random() * slots.length);
        var avail = [];
        for (var k = 0; k < pool.length; k++) { if (shown.indexOf(k) === -1) avail.push(k); }
        if (!avail.length) return;
        var pick = avail[Math.floor(Math.random() * avail.length)];
        var slot = slots[si];
        slot.classList.add("pop-out");
        setTimeout(function () {
          shown[si] = pick;
          render(slot, pool[pick]);
          slot.classList.remove("pop-out");
          slot.classList.add("pop-in");
          setTimeout(function () { slot.classList.remove("pop-in"); }, 560);
        }, 380);
      }, 2400);
    });
  }

  /* ---------- Card fan (hover / tap to reveal) ---------- */
  function initFan() {
    document.querySelectorAll("[data-fan]").forEach(function (fan) {
      var cards = Array.prototype.slice.call(fan.querySelectorAll(".fan__card"));
      var gallery = fan.closest(".gallery");
      var overlay = gallery && gallery.querySelector(".fan-overlay");
      function close() {
        cards.forEach(function (c) { c.classList.remove("active"); });
        if (overlay) overlay.classList.remove("open");
      }
      cards.forEach(function (card) {
        card.addEventListener("click", function () {
          var was = card.classList.contains("active");
          cards.forEach(function (c) { c.classList.remove("active"); });
          if (!was) card.classList.add("active");
          /* Blur the page behind the enlarged photo, matching the cart drawer scrim */
          if (overlay) overlay.classList.toggle("open", !was);
        });
      });
      /* Click the blurred backdrop or hit Escape to dismiss - same as the cart drawer */
      if (overlay) overlay.addEventListener("click", close);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    });
  }

  /* ---------- Endless drag-scroll rows (jar scroller, Instagram strip) ----------
     A real scroll container rather than a CSS-animated strip: trackpad, touch swipe and arrow
     keys all come for free, and the auto-advance becomes a nudge to scrollLeft each frame.

     Markup contract: [data-dragscroll] on the viewport, [data-dragscroll-track] on the row inside
     it, data-dragscroll-duration = seconds for one pass. The track must repeat its contents an
     EVEN number of times, so folding the position back into [0, half) is invisible. */
  function initDragScroll() {
    document.querySelectorAll("[data-dragscroll]").forEach(function (vp) {
      var track = vp.querySelector("[data-dragscroll-track]");
      if (!track) { return; }

      var pxPerSecond = 0;
      var half = 0;
      function measure() {
        half = track.scrollWidth / 2;
        var seconds = parseFloat(vp.getAttribute("data-dragscroll-duration")) || 60;
        pxPerSecond = (half > 0 && seconds > 0) ? half / seconds : 0;
      }
      measure();
      window.addEventListener("load", measure);
      window.addEventListener("resize", measure);

      function normalise(x) {
        if (half <= 0) { return x; }
        x = x % half;
        return x < 0 ? x + half : x;
      }

      /* Position is kept as a float here rather than incrementing scrollLeft directly: scrollLeft
         rounds to whole pixels, and the advance can be well under 1px per frame, so the movement
         would be rounded away every frame and the row would never move at all. */
      var pos = 0;
      var lastWritten = -1;
      var speed = reduceMotion ? 0 : 1;
      var target = speed;
      var flick = 0;
      var dragging = false;
      var lastFrame = 0;

      function tick(now) {
        var dt = lastFrame ? Math.min((now - lastFrame) / 1000, 0.05) : 0;
        lastFrame = now;

        /* Adopt anything the browser moved underneath us (trackpad, touch, arrow keys) rather
           than stamping our own position back over it. */
        if (lastWritten >= 0 && vp.scrollLeft !== lastWritten) { pos = vp.scrollLeft; }

        speed += (target - speed) * Math.min(dt * 5, 1);

        if (!dragging) {
          if (Math.abs(flick) > 2) {
            pos += flick * dt;
            flick *= Math.pow(0.05, dt);
          } else {
            flick = 0;
          }
          if (pxPerSecond > 0) { pos += pxPerSecond * speed * dt; }
        }

        pos = normalise(pos);
        /* Only write once the float has drifted a pixel from where the browser has it: writing
           every frame cancels the trackpad's own momentum scrolling. */
        if (Math.abs(pos - vp.scrollLeft) >= 0.75) { vp.scrollLeft = pos; }
        lastWritten = vp.scrollLeft;
        if (running) { requestAnimationFrame(tick); }
      }

      /* Optional data-dragscroll-max-width: run only at or below that viewport width. The
         recommended-products row uses it because it is a scroll row on phones but a static
         three-up grid on desktop - and without the gate this loop would keep running forever
         against an element that cannot scroll, burning a frame callback on every product page
         for no visible effect. Rows without the attribute (the jar scroller) always run. */
      var maxW = parseFloat(vp.getAttribute("data-dragscroll-max-width")) || 0;
      var running = false;
      function startLoop() {
        if (running) { return; }
        running = true;
        lastFrame = 0;
        requestAnimationFrame(tick);
      }
      function stopLoop() {
        running = false;
        pos = 0;
        lastWritten = -1;
        vp.scrollLeft = 0;
      }
      if (maxW > 0 && window.matchMedia) {
        var mq = window.matchMedia("(max-width: " + maxW + "px)");
        var syncLoop = function () { measure(); if (mq.matches) { startLoop(); } else { stopLoop(); } };
        if (mq.addEventListener) { mq.addEventListener("change", syncLoop); } else if (mq.addListener) { mq.addListener(syncLoop); }
        syncLoop();
      } else {
        startLoop();
      }

      function hold() { target = 0; }
      function release() { if (!reduceMotion && !dragging) { target = 1; } }
      vp.addEventListener("pointerenter", hold);
      vp.addEventListener("pointerleave", release);
      vp.addEventListener("focusin", hold);
      vp.addEventListener("focusout", release);

      /* Mouse drag only - touch and trackpad already scroll natively, with momentum we would
         only be throwing away by intercepting them. */
      var lastX = 0;
      var lastMoveAt = 0;
      var travelled = 0;
      var engaged = false;

      /* Distance that separates a click from a drag. Shared with the click guard below so the
         two can never disagree about which one just happened. */
      var DRAG_PX = 6;

      /* Nothing that interferes with a plain click may be applied here (#137). Both of these
         used to be, and between them they stopped the cards ever opening their product page:
           - setPointerCapture retargets the following click at the capturing element, so the
             <a> inside the card never received it;
           - the is-dragging class sets pointer-events:none on the track, so the hit test that
             decides the click target skipped the link too.
         Both are real requirements while dragging and harmless before it, so they now wait
         until the pointer has actually travelled (see engage() in pointermove). */
      vp.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) { return; }
        dragging = true;
        target = 0;
        flick = 0;
        travelled = 0;
        engaged = false;
        lastX = e.clientX;
        lastMoveAt = performance.now();
      });

      vp.addEventListener("pointermove", function (e) {
        if (!dragging) { return; }
        var t = performance.now();
        var dx = e.clientX - lastX;
        var dt = Math.max((t - lastMoveAt) / 1000, 0.001);
        lastX = e.clientX;
        lastMoveAt = t;
        travelled += Math.abs(dx);
        /* Past the threshold this is a drag, not a click: take the pointer so it keeps tracking
           if the cursor leaves the row, and switch off pointer-events on the cards so the browser
           does not start its own image/link drag. Once only. */
        if (!engaged && travelled > DRAG_PX) {
          engaged = true;
          vp.classList.add("is-dragging");
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }
        /* Applied as a delta, never an absolute target: an absolute one sweeps the whole track
           on any frame where the position wraps mid-drag. */
        pos = normalise(pos - dx);
        var sample = Math.max(Math.min(-dx / dt, 4000), -4000);
        flick = flick * 0.7 + sample * 0.3;
      });

      function endDrag(e) {
        if (!dragging) { return; }
        dragging = false;
        vp.classList.remove("is-dragging");
        /* Nothing moved for a moment before release - a considered stop, not a throw. */
        if (performance.now() - lastMoveAt > 120) { flick = 0; }
        if (engaged && e && e.pointerId != null) {
          try { vp.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        engaged = false;
        /* travelled is deliberately NOT cleared here - the click that ends a drag fires after
           pointerup, and the guard below needs it to know the click was a drag. */
      }
      vp.addEventListener("pointerup", endDrag);
      vp.addEventListener("pointercancel", endDrag);

      /* Swallow the click that ends a drag, so pulling the row across by a card or photo does
         not also open it. Capture phase, since the click lands on the child link. */
      vp.addEventListener("click", function (e) {
        if (travelled > DRAG_PX) {
          e.preventDefault();
          e.stopPropagation();
        }
        /* Cleared on every click, not only a swallowed one. Left set, a drag that ended without
           a click (released outside the row) would arm the guard and eat the next real click. */
        travelled = 0;
      }, true);
    });
  }

  /* ============================================================
     CART
     ============================================================ */
  /* ============================================================
     CART DRAWER  (open/close + money helper only)
     localStorage prototype cart removed - Shopify AJAX cart wired in M4.
     ============================================================ */
  function money(cents) {
    var s = "$" + (cents / 100).toFixed(2);
    var cfg = window.SN_CONFIG;
    if (cfg && cfg.currencyCodeEnabled && cfg.currencyCode) { s += " " + cfg.currencyCode; }
    return s;
  }

  function openCart() {
    var o = document.querySelector(".cart-overlay");
    var d = document.querySelector(".cart-drawer");
    if (o) o.classList.add("open");
    if (d) d.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var o = document.querySelector(".cart-overlay");
    var d = document.querySelector(".cart-drawer");
    if (o) o.classList.remove("open");
    if (d) d.classList.remove("open");
    document.body.style.overflow = "";
  }
  function initCart() {
    document.querySelectorAll("[data-open-cart]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    });
    document.querySelectorAll("[data-close-cart]").forEach(function (b) { b.addEventListener("click", closeCart); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    document.querySelectorAll(".signup__form").forEach(function (f) {
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = f.querySelector(".signup__submit");
        btn.textContent = "Grazie! Check your inbox.";
        btn.disabled = true;
        btn.style.width = "100%";
      });
    });
  }

  /* expose for inline handlers / page scripts */
  window.SN = {
    openCart: openCart,
    closeCart: closeCart,
    money: money
  };

  function initAll() {
    initStickyNav();
    initBurger();
    initReveal();
    initParallax();
    initCountUp();
    initAccordions();
    initCollectionFacets();
    initCarousels();
    initDragScroll();
    initReviewWall();
    initFan();
    initCart();
    initNewsletter();
  }

  /* Run now if the DOM is already parsed (e.g. offline bundle injects content
     after the load event), otherwise wait for it. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
